import React from 'react';
import { Card, CardGroup, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import MasterService from '../Services/masterService';
import { useNavigate } from 'react-router';
import { Link, NavLink } from 'react-router-dom';
import { ContainerType } from '../Models/Enum';
import { IMAGE_MAIN_ENDPOINT } from '../constant';




function FruitCard(props) {
  const masterService = MasterService.getInstance(); 
  
 

  var Months =  JSON.parse(props.item.FLD_1_7_3_3);
  if(Months != undefined && Months.length>0){
    var dateText = Months.map(({ Start, End }) => ` ${masterService.Months["Month" + Start]} - ${masterService.Months["Month" + End]}`).join(' | ');
  }


  return (


    <Card className='CustomCard' style={{ backgroundColor: props.item.FLD_0_1_12_12 , cursor: "pointer"}} as={NavLink}  to={props.item.URL} onClick={()=> {window.scroll(0,0)}} >
      <Card.Img variant="top" src={IMAGE_MAIN_ENDPOINT+(props.item.FLD_0_3_4_4 != undefined && props.item.FLD_0_3_4_4 != null && props.item.FLD_0_3_4_4)} />
      <Card.Body>
        <Card.Title className='fw-bold mb-0'>{props.item.Title}</Card.Title>
        <Card.Text>{props.item.FLD_0_2_1_1}</Card.Text>
        <span className="badge rounded-pill fw-normal text-white " style={{ backgroundColor: props.item.FLD_0_1_13_13 }}>{dateText}</span>        
      </Card.Body>
      <div className='SeasonalFruitArrow' style={{ backgroundColor: props.item.FLD_0_1_14_14  }} >
        <FontAwesomeIcon icon={faArrowRight} className='fa-xl' style={{ cursor: "pointer" }} />
      </div>
      <div className='availablity ' >
        <div className='text-wrap fw-bold text-white'>
        <small>{props.item.FLD_0_8_2_2 ? 'Available' : 'Not Available'}</small>
        </div>
      </div>
    </Card> 
 
  )
}


export default FruitCard; 

